import React from 'react';

import { ProductsGrid } from './components/ProductsGrid/ProductsGrid';
import { CoverDiv } from './components/CoverDiv/CoverDiv';
// import { Characteristics } from './components/Characteristics/Characteristics';
import { OurBrand } from './components/OurBrand/OurBrand';
import { MaterialsDiv } from './components/MaterialsDiv/MaterialsDiv';
import { Footer } from './components/Footer/Footer';
import { Slider } from './components/Slider/Slider';
import { Download } from './components/Download/Download';

function App() {
  return (
    <div className="App">
        <CoverDiv/>
        <Slider/>
        <OurBrand/>
        <MaterialsDiv/>
        <ProductsGrid/>
        <Download/>
        <Footer/>
    </div>
  );
}

export default App;
